var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":_vm.log.done ? 'success' : '',"pressed":_vm.log.done,"disabled":_vm.pending},on:{"click":_vm.clicked}},[_vm._v(_vm._s(_vm.log.done ? "Ja" : "Nein"))])}
var staticRenderFns = []

export { render, staticRenderFns }